/*
 * Copyright (c) 2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import App from 'apmui/App';
import EventTags from 'apmui/EventTags';

const app = App.get();

app.subscribeDefault(EventTags.CONFIGURE, (_, page) => {
    /* set page title */
    if (page.general.config.pageTitle) {
        document.title = page.general.config.pageTitle;
    }
});
